import React, { useEffect, useState, useCallback, useRef } from 'react';
import { connect, useSelector } from 'react-redux';
import moment from 'moment';
import { isEqual } from 'lodash'
import { useLocation } from 'react-router-dom';
import Select from 'react-select';
import PropTypes from 'prop-types';
import { PDFExport, savePDF } from '@progress/kendo-react-pdf';
import { useTranslation } from 'react-i18next';
import { Container, Row, Col, Card, CardBody } from 'reactstrap';
import Notification from 'rc-notification';
import SmallLoader from '../../../../shared/components/SmallLoader';
import { RTLProps } from '../../../../shared/prop-types/ReducerProps';
import SalesByReffererTable from './SalesByReffererTable';
import SalesByReffererShow from './SalesByReffererShow';
import { getShopifySalesByReffererDetails, handleLoader } from '../../../../redux/actions/SalesByReferrerAction';
import { getShopifySalesByReffererAllDetails, handleAllLoader } 
from '../../../../redux/actions/SalesByReferrerAllAction';
import { months } from '../../CompareMonth/helper';
import { setCurrencyFormat, findMonthsBetweenDates, getMonths } from '../../../../utils/helpers';
import { tableShopifyReferrer } from '../../helper';
import ViewSalesReportModal from '../../SalesCategoryByDay/ViewSalesReportModal';
import {
  filterShowWiseWithoutSKU as filterShowWise, filterDaillyMonthly,
  vendorNameMapping, sortType
} from '../../helper';

const SalesByRefferer = ({ dispatch, rtl }) => {
  const { t } = useTranslation('common');
  const location = useLocation();

  const currentYear = moment().format('YYYY');
  const preYear = moment().subtract(1, 'years').format('YYYY');
  const currentMonth = moment().format('MMM');
  const prevMonth = moment().subtract(6, 'months').format('MMM');

  const { SalesByReffererData,SalesByReffererAllData, salesChannelFilterData, 
    isLoading,isAllLoading } = useSelector(
    ({ salesByReferrerReducer,salesByReferrerAllReducer, marketPlaceReducer }) =>
    ({
        SalesByReffererData: salesByReferrerReducer?.SalesByReffererData,
        salesChannelFilterData: marketPlaceReducer.salesChannel,
        isLoading: salesByReferrerReducer?.isLoading,
        SalesByReffererAllData: salesByReferrerAllReducer?.SalesByReffererAllData,
        isAllLoading: salesByReferrerAllReducer?.isAllLoading,
    })
  );

  const salesChannelRef = useRef({})

  const [dataToShow, setDataToShow] = useState(SalesByReffererData?.modal?.data);
  const [dataToShowAll, setDataToShowAll] = useState(SalesByReffererAllData?.modal?.data);
  const [showMarketPlaceMessage, setShowMarketPlaceMessage] = useState(false)
  const [isOpen, setIsOpen] = useState(false);
  const [filterData, setFilterData] = useState({});
  const [selectedCompany, setSelectedCompany] = useState([]);
  const [maxValueObj, setMaxValueObj] = useState({})
  const [month2, setMonth2] = useState({ year: currentYear, month: currentMonth })
  const [month1, setMonth1] = useState({ year: preYear, month: prevMonth });
  const [tempMonth2, setTempMonth2] = useState({ year: currentYear, month: currentMonth });
  const [tempMonth1, setTempMonth1] = useState({ year: preYear, month: prevMonth })
  const [selectedShowOptions, setSelectedShowOptions] = useState(filterDaillyMonthly?.[0]);

  const yearOptions = [];
  for (let year = 2016; year <= currentYear; year += 1) {
    yearOptions.push({ label: year, value: year })
  }

  const monthOptions = months.map(item => ({ label: item, value: item }));

  const date1 = `${month1?.year}-${month1?.month}`;
  const date2 = `${month2?.year}-${month2?.month}`;

  const selectedFromMonth = month1.month;
  const selectedFromYear = month1.year;
  const selectedToMonth = month2.month;
  const selectedToYear = month2.year;

  const selectFromDate = selectedFromMonth + selectedFromYear;
  const selectToDate = selectedToMonth + selectedToYear;
  const selectedMonths = getMonths(moment(selectFromDate, 'MMMYYYY'), moment(selectToDate, 'MMMYYYY'))

  const filterBasedOnFilter = (item) => {
    const filters = Object.keys(filterData);
    let flag = true
    // eslint-disable-next-line no-restricted-syntax
    for (const i of filters) {
      const filter = filterData[i];
      const filtersArray = filter?.reduce((acc, fil) => [...acc, fil?.value], []) ?? [];
      if (filtersArray?.length && !filtersArray.includes(item[i]?.toLowerCase())) {
        flag = false
      }
    }

    return flag
  }

  const container = React.useRef(null);
  const exportToPDF = () => {
    // console.log('Hello')
    Notification.newInstance({}, (notification) => {
      notification.notice({
        content: 'PDF loading......',
        duration: 5,
        style: {top: 120, fontWeight: "bold"},
        maxCount: 10
      });
    });
    const dvTable = document.getElementById('dvTable');
    // const dvChartF = document.getElementById('dvChartFilter');
    const dvChartV = document.getElementById('dvChartView');
    dvTable.style.display = "none"; 
    // dvChartF.style.display = "none";  
    dvChartV.style.display = "none";    
    const element = container.current || document.body;
    
    savePDF(element, {
      paperSize: "auto",
      Header: "test",
      margin: { left: "1cm", top: "1cm", right: "1cm", bottom: "1cm" },
     // margin: "2cm",
     // forcePageBreak: ".page-break",
    //   landscape: true,
    //  multiPage: true,
      fileName: `Sales By Refferer Report ${new Date().getFullYear()}`,
    })
    dvTable.style.display = "block";  
    // dvChartF.style.display = "block";  
    dvChartV.style.display = "block"; 
  }

  const callApi = () => {    
    setShowMarketPlaceMessage(false)
    dispatch(handleLoader(true));
    dispatch(getShopifySalesByReffererDetails({
      fromYear: tempMonth1?.year,fromMonth: moment().month(tempMonth1.month).format('MM'),
      toYear: tempMonth2?.year,toMonth: moment().month(tempMonth2.month).format('MM')
    }));
    dispatch(handleAllLoader(true));
    dispatch(getShopifySalesByReffererAllDetails());
  }

  const handleApplyDate = () => {
    const startDate = `${tempMonth1?.year}-${tempMonth1?.month}`;
    const endDate = `${tempMonth2?.year}-${tempMonth2?.month}`

    const monthsBetween = findMonthsBetweenDates(startDate, endDate);
    if (monthsBetween?.length > 0) {
      setMonth1(tempMonth1);
      setMonth2(tempMonth2);
      callApi();
    } else {
      Notification.newInstance({}, (notification) => {
        notification.notice({
          content: 'Please select minimum two months'
        });
      });
    }
  }

  const handleYearMonthChange = ({ isFrom, field, value }) => {

    if (isFrom) {
      setTempMonth1({ ...tempMonth1, [field]: value?.value });
    } else {
      setTempMonth2({ ...tempMonth2, [field]: value?.value })
    }
  }

  // eslint-disable-next-line react/prop-types
  const RenderYearAndMonth = ({ isFrom }) => (
    <Col sm="4">
      <Card className="pb-3">
        <CardBody className="min-w-50 p-3">
          <Row className="justify-content-space-between">
            <Col sm="6">
              <div className="form__form-group mb-0">
                <span className="form__form-group-label">{isFrom ? 'Previous' : 'Current'} Year</span>
                <div className="form__form-group-field">
                  <Select
                    value={isFrom ? { value: tempMonth1?.year, label: tempMonth1?.year }
                      : { value: tempMonth2?.year, label: tempMonth2?.year }}
                    options={yearOptions}
                    clearable={false}
                    placeholder="Select Year"
                    className="select_filter-110"
                    onChange={value => handleYearMonthChange({ isFrom, field: 'year', value })}
                    classNamePrefix="react-select"
                    name={isFrom ? 'from' : 'to'}
                  />
                </div>

              </div>
            </Col>
            <Col sm="6">
              <div className="form__form-group mb-0">
                <span className="form__form-group-label">Month</span>
                <div className="form__form-group-field">
                  <Select
                    value={isFrom ? { value: tempMonth1?.month, label: tempMonth1?.month }
                      : { value: tempMonth2?.month, label: tempMonth2?.month }}
                    options={monthOptions}
                    clearable={false}
                    placeholder="Select Month"
                    className="select_filter-110"
                    onChange={value => handleYearMonthChange({ isFrom, field: 'month', value })}
                    classNamePrefix="react-select"
                    name={isFrom ? 'fromMonth' : 'toMonth'}
                  />
                </div>
              </div>
            </Col>
          </Row>
        </CardBody>
      </Card>
    </Col>
  );

  

  const companyOptions = [];
  // eslint-disable-next-line array-callback-return
  SalesByReffererData?.modal?.filters?.sort((a, b) => a.sortingOrder - b.sortingOrder).map((data) => {
    data.filterData.forEach((element) => {
        companyOptions.push({
            value: element.key,
            label: element.shortValue
        });
    });
});
const sortedCompanyOptions = companyOptions.sort((a, b) => a.label > b.label ? 1 : -1)
  
  const setMaxValue = useCallback((val) => {
    if (!maxValueObj[val]) {
      setMaxValueObj({ ...maxValueObj, [val]: Number(val) })
    }
  }, [maxValueObj])

    
  // eslint-disable-next-line react/prop-types

  const changeFilter = (value) => {
    setSelectedCompany(value)
  };

  const changeFilterForShow = (value) => {
    setSelectedShowOptions(value)
  };

  useEffect(() => {
    callApi();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setDataToShow(SalesByReffererData?.modal?.data);
    setDataToShowAll(SalesByReffererAllData?.modal?.data);
  }, [SalesByReffererData, SalesByReffererAllData]);

  useEffect(() => {
    const OptChennel = 'salesChannel';
    if (salesChannelFilterData && !isEqual(salesChannelFilterData, salesChannelRef?.current?.salesChannel || [])) {
      setShowMarketPlaceMessage(true)
      salesChannelRef.current = { [OptChennel]: salesChannelFilterData }
      setFilterData({ ...filterData, [OptChennel]: salesChannelFilterData });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [salesChannelFilterData])

  let dataToShowForDatesSelected = [];
  const monthsBetweenDates = findMonthsBetweenDates(date1, date2);
  for (let i = 0; i < monthsBetweenDates.length; i += 1) {
    const [year, month] = monthsBetweenDates?.[i]?.split('-');
    let monthWiseData = dataToShow?.[0]?.yearlySales?.[year]?.monthlySales?.[month] ?? [];
    if (monthWiseData) {
      monthWiseData = monthWiseData.filter(item =>
        filterBasedOnFilter(item))?.map(item => ({
          ...item,
          day: Number(item.day).toFixed(0),
          salesMonth: month,
          sortedDate: new Date(`${year}-${moment().month(month).format('MM')}-${Number(item.day).toFixed(0)}`),
          salesYear: year
        }))
      dataToShowForDatesSelected = dataToShowForDatesSelected?.concat(monthWiseData);

    }
  }
  dataToShowForDatesSelected = dataToShowForDatesSelected?.sort((a, b) => 
   b.sortedDate - a.sortedDate)
   if (selectedCompany?.length) {
     const selected = selectedCompany?.reduce((acc, item) => {
         acc[item?.value] = item.value
         return acc
     }, {})
     dataToShowForDatesSelected = dataToShowForDatesSelected.filter(item => selected[item.companyName])
 }
 const dataToShowForAll = dataToShowAll ?? [];
  const tableHeader = [
    {
      Header: 'Day',
      accessor: 'day',
      disableGlobalFilter: false,
      width: 150,
      sortType
  },
  {
      Header: 'Referrer Name',
      accessor: 'referrerName',
      disableGlobalFilter: false,
      width: 300,    
      sortType
  },
  {
      Header: 'Total Sales',
      accessor: 'totalSales',
      disableGlobalFilter: false,
      width: 200,
      rightAlign: true,
      Cell: ({ cell: { row: { original } } }) => {
          // eslint-disable-next-line react/prop-types
          const { totalSales } = original
          return setCurrencyFormat(Number(totalSales).toFixed(2), true)
      },
      sortType
  }]

  const viewReportButton = () => (
    <div className="view-report">
      <button
        type="button"
        className="view-report btn btn-primary btn-sm"
        onClick={() => setIsOpen(true)}
      >
        View Report
      </button>
    </div>
  )
  const allCategories = {}
  const currentDataByCategory = {};

  const modalData = dataToShowForDatesSelected?.map(item => ({
    ...item,    
    day: moment(`${item.salesMonth}-${Number(item.day).toFixed(0)}-${item.salesYear}`,'MMM-D-YYYY')
    .format('MMM-YYYY-DD')  
  }))

  console.log(modalData)
  return (
    <Container className="dashboard">
      <Row className="category-sales">
        <Col sm="12">
          <Card className="pb-3">
            <CardBody className="min-w-50 p-3">
              <div className="card__title mb-2">
                <h5 className="bold-text card__title-center">Sales By Referrer</h5>
              </div>
              <Row className="justify-content-space-between align-items-center">
              <Col sm="4" md="2">
                  <div className="form__form-group">
                    <span className="form__form-group-label">Type</span>
                    <div className="form__form-group-field">
                      <Select
                        value={selectedShowOptions}
                        options={filterDaillyMonthly}
                        clearable={false}
                        placeholder="Select "
                        className="select_filter"
                        onChange={changeFilterForShow}
                        classNamePrefix="react-select"
                      // isMulti
                      />
                    </div>

                  </div>
                </Col>
                <Col sm="10" md="10">
                <Row className="justify-content-right align-items-center ">
                    <RenderYearAndMonth isFrom />
                    <Col sm='1' className="filter-to-position">~</Col>
                    <RenderYearAndMonth />
                    <Col sm="3" className="p-0 filter-to-position">
                      <button className="btn btn-sm btn-primary
                                             apply-date-button"
                        type="button" onClick={handleApplyDate}>
                        Apply</button> 
                        <button className="btn btn-sm btn-primary
                                             apply-date-button"  type="button"
                                             title='Export to pdf' disabled={isLoading}
                                    onClick={exportToPDF}>Export PDF</button>
                    </Col>                   
                  </Row>
                </Col>              
              </Row>
            </CardBody>
          </Card>
        </Col>
      </Row>  
      <div id="divToPrint" ref={container}>
      <Card className="pb-3">
        <CardBody className="">
          <div className="top-location"
            style={{ minHeight: '400' }}>
            <div >
              {isLoading ? <div style={{ minHeight: '200px' }}
                className="row align-items-center justify-content-center">
                <SmallLoader loading={isLoading} />
              </div>
                : <SalesByReffererShow
                  dir={rtl.direction}
                  data={dataToShowForDatesSelected}
                  title={`Sales By Referrer By ${selectedShowOptions?.label}`}
                  viewReportButton={viewReportButton}
                  optionShow={selectedShowOptions}
                  companyBasedOn='companyName'
                />}
            </div>
          </div>
        </CardBody>
      </Card>
      <Card className="pb-3">
        <CardBody className="">
          <div className="top-location"
            style={{ minHeight: '400' }}>
            <div >
              {isLoading ? <div style={{ minHeight: '200px' }}
                className="row align-items-center justify-content-center">
                <SmallLoader loading={isLoading} />
              </div>
                : <SalesByReffererTable
                data={dataToShowForAll}
                tableHeaderData={tableShopifyReferrer}
                />}
            </div>
          </div>
        </CardBody>
      </Card>
      </div>
      <ViewSalesReportModal
        modalData={modalData}
        isOpen={isOpen}
        handleModal={setIsOpen}
        tableHeaderData={tableHeader}
        title='Sales By Referrer Report'
        fileName='Sales By Referrer Report'
      />
    </Container>
  );
};

SalesByRefferer.propTypes = {
  dispatch: PropTypes.func.isRequired,
  rtl: RTLProps.isRequired,
}

export default connect(state => ({
  rtl: state.rtl,
}))(SalesByRefferer);